import PaymentService from 'src/common/api/payment.service';

export async function fetchAllPaymentMethods({ commit }) {
  const response = await PaymentService.getAll();
  if (response.status === 200) {
    commit('updateAllPaymentMethods', { paymentMethodsMethods: response.data });
  }
}
